import { FlexBox, StackPanel } from '@agilepoint/wat-react-ux';
import styled from 'styled-components';

export const UncheckedState = styled.span<{ $isActive: boolean, $size?: string }>`
    width: ${({ $size }) => $size ?? '12px'};
    height: ${({ $size }) => $size ?? '12px'};
    border: ${({ $isActive }) => ($isActive ? '2px' : '1px')} solid ${({ $isActive, theme: { mobileAppAccelerator: { semanticColors } } }) => ($isActive ? semanticColors.wizard.activeStepColor : semanticColors.grayVariant2)};
    border-radius: 30px;
`;

export const ScrollableStackPanel = styled(StackPanel)`
    overflow-y: auto;
`;

export const SectionLabel = styled(FlexBox).attrs({ justifyContent: 'center', alignItems: 'center', width: '100%' })`
    height: ${({ height }) => height ?? '30px'};
    color: ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant3};
    background-color: ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant6};
    border-radius: ${({ theme: { semantics: { borderRadius } } }) => borderRadius.curvedMedium};
`;

export const FooterBlock = styled(FlexBox)`
    border-top: 1px solid ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant5};
    padding-top: 20px;
    box-sizing: border-box;
`;
